import React from 'react';
import { twMerge } from 'tailwind-merge';
import logoRed from '@/assets/logo-red.webp';
import logoBlack from '@/assets/logo-black.webp';

function Loader({ pct, className }) {
  return (
    <div className={twMerge('relative', className)}>
      <img
        src={logoBlack}
        alt=""
        className="absolute left-0 top-0 size-full object-contain"
      />
      <img
        src={logoRed}
        alt=""
        className="absolute left-0 top-0 size-full object-contain"
        style={{ clipPath: `inset(0 ${100 - pct * 100}% 0 0)` }}
      />
    </div>
  );
}

export default Loader;
